import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, FILE_URL } from "@/lib/api";
import { Folder as FolderIcon } from "lucide-react";

export default function SharedFolder() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/shared-folder/${token}`).then(({ data }) => setData(data)).catch(() => setData(null)).finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="max-w-6xl mx-auto px-6 pt-20 text-[#2A2823]/60">Loading…</div>;
  if (!data) {
    return (
      <main className="max-w-3xl mx-auto px-6 pt-20 text-center">
        <h1 className="font-serif-display text-4xl text-[#2A2823]">This folder link is quiet.</h1>
        <p className="text-[#2A2823]/60 mt-3">It may have been taken down, or the link is off.</p>
        <Link to="/grove" className="mt-6 inline-block accent-label text-[#4E5A3D] underline">Wander The Grove →</Link>
      </main>
    );
  }
  return (
    <main className="max-w-6xl mx-auto px-6 pt-12 pb-24">
      <div className="accent-label text-[#B79256]">shared folder · read-only</div>
      <h1 data-testid="shared-folder-name" className="font-serif-display text-5xl sm:text-6xl text-[#2A2823] mt-3 leading-none flex items-center gap-3">
        <FolderIcon className="w-8 h-8 text-[#4E5A3D]" strokeWidth={1.5}/> {data.folder.name}
      </h1>
      <p className="text-[#2A2823]/60 mt-3">Shared by <b className="text-[#4E5A3D]">{data.owner_name}</b>. Nothing else from their Grove is visible.</p>

      {data.ideas.length === 0 ? (
        <div data-testid="shared-empty" className="mt-12 text-center py-24 border border-dashed border-[#B79256]/40 rounded-3xl">
          <p className="font-serif-display text-3xl text-[#4E5A3D]">Nothing filed here yet.</p>
        </div>
      ) : (
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="shared-ideas">
          {data.ideas.map((idea) => (
            <Link key={idea.id} to={`/idea/${idea.id}`} data-testid={`shared-item-${idea.id}`} className="group block">
              <div className="overflow-hidden rounded-3xl bg-white border border-[#B79256]/20 shadow-[0_10px_40px_rgb(42,40,35,0.06)] transition-transform duration-300 ease-out group-hover:-translate-y-1">
                <div className="w-full aspect-[4/5] bg-[#B79256]/5">
                  {idea.photo_path && <img src={FILE_URL(idea.photo_path)} alt="" className="w-full h-full object-cover"/>}
                </div>
                <div className="p-5">
                  <div className="accent-label text-[#B79256]">{idea.category}</div>
                  <h3 className="font-serif-display text-2xl text-[#2A2823] leading-tight mt-1">{idea.title}</h3>
                  <p className="text-xs text-[#2A2823]/50 mt-3">by <span className="text-[#4E5A3D]">{idea.author_name}</span></p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </main>
  );
}
